// @flow

import React from 'react';
import { Link }             from 'react-router-dom';
import { connect }          from 'react-redux';
import { getTranslate }     from 'react-localize-redux';
import './header.css';

const Header = ({translate}) => {
  return (
    <div className="header">
      <header className="container-fluid">
        <div className="col-md-4 logo-users"><Link to='/'>{translate('common.site_title')}</Link></div>
        <div className="col-md-8 info">
          <ul>
            <li className="help"><Link to='https://www.forsikringsportalen.dk/om-os/spoergsmaal-svar/' target='_blank'>{translate('common.header.help')}</Link></li>
            <li className="tel hidden">{translate('common.header.telephone')}</li>
            <li className="mail"><Link to={'mailto:' + translate('common.header.email')}>{translate('common.header.email')}</Link></li>
          </ul>
        </div>
      </header>
    </div>
  );
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale)
});

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/session/header/header.js